/** Shared floor + order-entry copy (used by the cashier and service interfaces). */
export const enOrder = {
  // ---- Floor ----------------------------------------------------------------------
  'floor.empty': 'No tables yet — add floors and tables in the back office.',
  'floor.filter': 'Floor',
  'floor.tileLabel': 'Table {name}, {status}',
  'floor.capacity': '{count} seats',
  'floor.guests': '{count} guests',
  'floor.newOrders': '{count} new guest orders',
  'floor.newOrdersShort': 'New',
  'floor.openFor': 'Open {minutes} min',
  'floor.needsRelease': 'Release after cleaning',
  'floor.guestCount': 'Number of guests',
  'floor.openTitle': 'Open table {name}',
  'floor.open': 'Open table',
  'floor.opening': 'Opening…',
  'floor.opened': 'Table {name} opened.',
  'floor.release': 'Table is clean — release',
  'floor.releasing': 'Releasing…',
  'floor.released': 'Table {name} is available again.',
  'floor.noSessionTitle': 'Table {name} has no open session',
  'floor.noSessionText': 'Open the table with the number of guests to start an order.',
  'floor.outOfService': 'This table is out of service. A manager can enable it in the back office.',
  'floor.cleaningText': 'The bill is settled. Release the table once it has been cleaned.',
  'floor.reservedText': 'This table is reserved.',
  'floor.backToFloor': 'Back to floor',
  'floor.notFound': 'This table does not exist in this branch.',
  'floor.sessionSummary': '{guests} guests · open {minutes} min',
  'floor.serverName': 'Server: {name}',

  // ---- Quantity -------------------------------------------------------------------
  'order.qty.label': 'Quantity',
  'order.qty.decrease': 'Decrease',
  'order.qty.increase': 'Increase',
  'order.qty.decreaseItem': 'Decrease quantity of {name}',
  'order.qty.increaseItem': 'Increase quantity of {name}',

  // ---- Menu -------------------------------------------------------------------------
  'order.menu.title': 'Menu',
  'order.menu.empty': 'The menu is empty — add categories and items in the back office.',
  'order.menu.categories': 'Menu categories',
  'order.menu.search': 'Search menu',
  'order.menu.noMatch': 'No menu items match.',
  'order.menu.hasOptions': 'With options',
  'order.menu.soldOut': 'Sold out',
  'order.menu.outOfStock': 'Out of ingredients',
  'order.menu.added': '{name} added.',

  // ---- Modifiers ------------------------------------------------------------------
  'order.mod.ruleOptional': 'Optional · up to {max}',
  'order.mod.ruleExact': 'Required · choose {count}',
  'order.mod.ruleRange': 'Required · choose {min}–{max}',
  'order.mod.errorMin': 'Choose at least {min}.',
  'order.mod.errorMax': 'Choose at most {max}.',
  'order.mod.selected': '{count} selected',
  'order.mod.previewTotal': 'Estimated',
  'order.mod.add': 'Add to order',

  // ---- Notes ----------------------------------------------------------------------
  'order.notes.label': 'Kitchen note',
  'order.notes.placeholder': 'e.g. no onions, sauce on the side',
  'order.notes.shown': 'Note: {notes}',
  'order.notes.editItem': 'Edit note for {name}',
  'order.notes.title': 'Note for {name}',

  // ---- Cart -----------------------------------------------------------------------
  'order.cart.title': 'Order',
  'order.cart.number': 'No. {number}',
  'order.cart.empty': 'No items yet. Pick from the menu.',
  'order.cart.drafts': 'Not sent yet',
  'order.cart.sent': 'Sent to the kitchen',
  'order.cart.draftTotal': 'Not sent yet',
  'order.cart.submittedTotal': 'Ordered',
  'order.removeItem': 'Remove {name}',
  'order.submit.action': 'Send to kitchen ({count})',
  'order.submit.pending': 'Sending…',
  'order.submit.done': 'Sent to the kitchen.',
  'order.issue.title': 'The menu changed since these items were added. Remove and add them again:',
  'order.issue.price_changed': 'price changed',
  'order.issue.unavailable': 'no longer available',
  'order.issue.modifiers_changed': 'options changed',
  'order.issue.other': 'no longer matches the menu',
  'order.serve.select': 'Mark {name} as served',
  'order.serve.action': 'Mark served ({count})',
  'order.serve.pending': 'Saving…',
  'order.serve.done': 'Marked as served.',
  'order.cancel.action': 'Cancel item',
  'order.cancel.title': 'Cancel {name}?',
  'order.cancel.description':
    'This item was already sent to the kitchen. The reason is recorded in the audit trail.',
  'order.cancel.reason': 'Reason',
  'order.cancelOrder.action': 'Cancel order',
  'order.cancelOrder.title': 'Cancel order {label}?',
  'order.cancelOrder.body':
    'Every item is cancelled and its kitchen tickets close. If the order has a bill, void it first.',
  'order.cancelOrder.pending': 'Cancelling…',
  'order.cancelOrder.done': 'Order {label} cancelled',
  'order.cancel.confirm': 'Cancel item',
  'order.cancel.pending': 'Cancelling…',
  'order.cancel.reasonShown': 'Cancelled: {reason}',

  // ---- Order type & channel (takeaway / delivery) ---------------------------------
  'order.type.dine_in': 'Dine-in',
  'order.type.takeaway': 'Takeaway',
  'order.type.delivery': 'Delivery',
  'order.channel.walk_in': 'Walk-in',
  'order.channel.gofood': 'GoFood',
  'order.channel.grabfood': 'GrabFood',
  'order.channel.shopeefood': 'ShopeeFood',
  'order.channel.other': 'Other platform',
  'order.label.table': 'Table {name}',
  'order.number': 'Order {number}',
  'order.ref': 'Platform order {ref}',
  'order.customer': 'Customer: {name}',
} as const;
